export default __webpack_public_path__ + "static/media/a020-ngo-4.ad1ae308.svg";